export default {
  name: 'countdown-anim',
  components: {},
  props: [],
  data() {
    return {
      start: 0,
      elapsed: 0,
      timeout: undefined,
    };
  },
  computed: {
    show5: function() {
      return this.elapsed <= 800;
    },
    show4: function() {
      return this.elapsed > 800 && this.elapsed <= 1600;
    },
    show3: function() {
      return this.elapsed > 1600 && this.elapsed <= 2400;
    },
    show2: function() {
      return this.elapsed > 2400 && this.elapsed <= 3200;
    },
    show1: function() {
      return this.elapsed > 3200;
    },
  },
  mounted() {
    this.start = Date.now();
    this.updateTimer();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: {
    updateTimer() {
      clearTimeout(this.timeout);
      this.elapsed = Date.now() - this.start;
      this.timeout = setTimeout(this.updateTimer, 100);
    },
  },
};


